import styled from 'styled-components';
import { Button } from '@cashfree-intl/coherent';
import { IPreferenceValueProps, IStyledCrossProps } from './types';

export const PreferenceCard = styled.div`
  padding: 1.5rem;
  width: 100%;
  background: #ffffff;
  border-radius: 0.75rem;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 0.5rem;
`;

export const PreferenceChips = styled.div`
  margin-top: 2rem;
  white-space: normal;
`;

export const PreferenceValue = styled.div<IPreferenceValueProps>`
  background: ${props => (props.verified ? 'var(--PRIMARY)' : '#ececec')};
  color: ${props => (props.verified ? '#fff' : '#000')};
  border-radius: 23px;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 0.5rem 1rem;
  font-family: 'proxima-nova-medium';
  display: inline-block;
  clear: both;
  cursor: pointer;
`;

export const TogglePreference = styled.div`
  display: flex;
`;

export const StyledCross = styled.span<IStyledCrossProps>`
  color: ${props => (props.verified ? '#fff' : '#000')};
`;

export const StyledLinkButton = styled(Button)`
  padding-left: 0;
  padding-top: 0;
  font-family: 'proxima-nova-medium';
`;
